import { createFileRoute } from '@tanstack/react-router';
import BundleManagement from '../../components/manager/BundleManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/bundles')({
  component: BundleManagementRoute,
});

function BundleManagementRoute() {
  return (
    <ManagerPortal>
      <BundleManagement />
    </ManagerPortal>
  );
}
